<template>
  <div class="card shadow rounded border-0 pt-2 mb-3 pricing-rates business-rate">
    <div class="row mx-2">
      <div class="col-md-9">
        <p>
          <span class="fw-bold h4" v-if="exam.item_name">{{ exam.item_name }} <br></span>
          <span class="fw-bold h4">{{ exam.exam_name }}</span> <br>
          <b>Código: </b> {{exam.exam_tuss_code}} <br>
          <span class="text-truncate-2">{{ exam.item_description }}</span>
        </p>
      </div>
      <div class="col-md-3 align-content-center mb-2">
        <div class="text-end text-md-start">
          <button
            class="btn btn-primary ms-2 btn-sm w-100 w-md-auto mb-1 mb-md-0"
            type="button"
            v-if="exam.alreadyExists"
            disabled
          >
            <i class="fa fa-shopping-bag me-2"></i> Adicionado
          </button>
          <button
            class="btn btn-primary ms-2 btn-sm w-100 w-md-auto"
            type="button"
            @click="addExam(exam)"
            v-else
          >
            <i class="fa fa-shopping-bag me-2"></i> Adicionar
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "ExamCard",
  props: ['exam'],
  methods: {
    addExam(exam) {
      this.$emit("addExam", exam)
    }
  }
}
</script>

<style scoped>
.text-truncate-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;     /* Limita a 2 linhas */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>